import script from "./Review.vue?vue&type=script&setup=true&lang=js"
export * from "./Review.vue?vue&type=script&setup=true&lang=js"

import "./Review.vue?vue&type=style&index=0&id=b6e669a6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6e669a6"]])

export default __exports__